import React, { useEffect, useState } from "react";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";

function Footer({ isDarkMode,staticPagesLanguage}) {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  const token = localStorage.getItem("token");

  return (
    
      <p class={`footertext pt-3 ${isDarkMode ? "text-light " : "text-light "}`}>
        {translations.footerTxt1[!token ? staticPagesLanguage :language]}© {currentYear} FIDGI Communications.{" "}
        {translations.footerTxt2[!token ? staticPagesLanguage :language]}
      </p>
    
  );
}

export default Footer;
